export default "__VITE_ASSET__b306e603__"